/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'MeetingPerson',

    components: {
        Badge,
        BaseSelect
    },

    props: {
        person: {
            type: Object,
            required: true
        },

        acceptance: {
            type: String,
            default: ''
        },

        presence: {
            type: String,
            default: 'pending'
        },

        isOrganizer: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        const STATUS_CLASS_MAP = {
            accepted: 'success',
            pending: 'alert-alt',
            declined: 'no'
        };

        let status = 'pending';

        if (this.acceptance === 'yes') {
            status = 'accepted';
        } else if (this.acceptance === 'no') {
            status = 'declined';
        }

        const fullPosition = this.$utils.pax.getFullPosition({ company: this.person._representation_line2, position: this.person._representation_line3 });
        const isExternal = this.person.fp_type === 'prospect';
        const externalPaxLabel = this.$i18n.t('generic_form.external_picker.external_participant');

        return {
            badgeClass: STATUS_CLASS_MAP[status],
            fullName: this.$utils.pax.getFullName(this.person),
            role: isExternal ? externalPaxLabel : fullPosition,
            status,
            presenceOptions: [
                { value: 'attended', label: this.$t('meetings.details.presence.attended') },
                { value: 'no-show', label: this.$t('meetings.details.presence.no-show') },
                { value: 'pending', label: this.$t('meetings.details.presence.pending') },
            ],
        };
    },

    methods: {
        handleInput(input) {
            this.$emit('presence-change', { presence: input ?? 'pending', person: this.person });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meeting-person"},[_c('div',{staticClass:"details"},[(_vm.fullName)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.fullName)+" "+_vm._s(_vm.isOrganizer ? ("(" + (_vm.$t("meetings.details.organizer")) + ")") : ''))]):_vm._e(),(_vm.role)?_c('div',{staticClass:"role"},[_vm._v(_vm._s(_vm.role))]):_vm._e(),_c('badge',{staticClass:"solid",class:_vm.badgeClass},[_vm._v(_vm._s(_vm.$t(("meetings.details.statuses." + _vm.status))))])],1),_c('div',{staticClass:"status"},[_c('base-select',{staticClass:"presence",attrs:{"emit-option-value-only":true,"name":("meeting-person-" + (_vm.person._id) + "-presence"),"allow-empty":false,"has-default":true,"options":_vm.presenceOptions,"value":_vm.presence},on:{"input":_vm.handleInput}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MeetingPerson.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__